import { createFileRoute } from '@tanstack/react-router';

import { queryShowcases } from 'hooks/data/useShowcases';

import { ShowcaseView } from 'views/ShowcaseView';

export const Route = createFileRoute('/_auth/_layout/showcases/')({
  component: ShowcaseView,
  beforeLoad: () => {
    return {
      backTarget: '/home/',
    };
  },
  loader: async ({ context: { queryClient } }) => {
    return queryShowcases(queryClient);
  },
});
